export class ApplicationUserModel {
  email: string;

  constructor(email: string) {
    this.email = email;
  }
}



// WEBPACK FOOTER //
// ./src/models/application-user.model.ts